module.exports = __webpack_public_path__ + "static/discount-coupons-91fa3645c3d153e6bab4eca26cdd4a3b.svg";